import sortBy from "lodash/sortBy";

import db from "@/db";

export default {
  namespaced: true,
  state: {
    advisors: [],
  },
  mutations: {
    setAdvisors(state, advisors) {
      state.advisors = advisors;
    },
  },
  actions: {
    async loadAndListen({ commit }) {
      db.collection("advisors").onSnapshot((advisorsRef) => {
        const advisors = db.snapshotToArray(advisorsRef);
        commit("setAdvisors", sortBy(advisors, [(a) => a.name.toLowerCase()]));
      });
    },
    async addAdvisor({ dispatch }, { name, email }) {
      //TODO - CHECK FOR DUPLICATES
      //TODO - CHECK FOR VALID EMAIL
      //TODO - Error Check
      try {
        await db
          .collection("advisors")
          .add({ name, email, _created: new Date() });
        dispatch("raiseSuccess", "Advisor created!");
        // TODO - RAISE SUCCESS
      } catch (e) {
        console.error(e);
      }
    },
    async removeAdvisor({ commit }, id) {
      try {
        await db.doc(`advisors/${id}`).delete();
        // TODO - RAISE SUCCESS
      } catch (e) {
        console.error(e, commit);
        // TODO - RAISE ERROR
      }
    },
  },
};
